/**
 * Browser cookie handling library.
 *
 * @module common/cookie-utils
 */

/**
 * Get cookie by  name
 * @param {String} name
 * @method
 */
export const getCookie = get;
export function get(name) {
  if (!name) return null;
  return _getCookie(name);
}
/**
 * Set or create a cookie
 * @param {String} name
 * @param {String} value
 * @param {Int} expiresIn (in milliseconds)
 * @method
 */
export const setCookie = set;
export function set(name, value, expiresIn) {
  if (!name || !value) return;

  let cookie = _getCookie(name);
  if (cookie) remove(name);
  document.cookie = createCookie(name, value, expiresIn);
}
/**
 * Remove cookie by name
 * @param {string} name
 * @method
 */
export const removeCookie = remove;
export function remove(name) {
  if (!name) return;
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// --------------------- Helpers -------------------- //

function _getCookie(cname) {
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find((cookie) => cookie.indexOf(cname) === 0);
  return cookie ? cookie.substring(cname.length + 1) : null;
}

/**
 * Creates new cookie on the "/" path
 * @param {String} name
 * @param {String} value
 * @param {Int} expiresIn
 * @private
 */
function createCookie(name, value, expiresIn) {
  let cookieStr = name + '=' + value + ';path=/';
  if (expiresIn) {
    let dateTimestamp = new Date().getTime() + expiresIn;
    cookieStr += '|' + new Date(dateTimestamp);
  }
  cookieStr += ';';

  return cookieStr;
}
